import React from 'react';
import { motion } from 'framer-motion';
import { infoSources, painPoints, selfQuestions } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Ti riconosci in questa situazione" className="bg-obsidian text-white" data-id="element-157" data-mp="2lp55ksdk54u7">
      <div className="mx-auto max-w-5xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "20px"
    }} data-id="element-158" data-mp="26wbmyy2zo8lb">
        <div className="max-w-3xl" data-id="element-159" data-mp="1xxrdmnjbjb9r">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-none sm:text-6xl" data-id="element-160" data-mp="1xwolkca9f2s9">
            Ti riconosci in questa situazione?
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/75" data-id="element-161" data-mp="1nzk0kfs5hdd1">
            Ti stai preparando per un triathlon di lunga distanza, ma ogni volta che provi a organizzare il
            tuo percorso finisci per sentirti sopraffatto dalla quantità di informazioni.
          </p>
        </div>

        <div className="mt-10 grid gap-10 lg:grid-cols-[1fr_1.4fr] lg:gap-14" data-id="element-162" data-mp="3nco0yb4h1ogc">
          <div data-id="element-163" data-mp="3nalcvwmvq5e9">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-164" data-mp="1z0ot0se0bvgt">Hai a disposizione</p>
            <ul className="mt-4 flex flex-wrap gap-2" data-id="element-165" data-mp="1u1tyit6ogigv">
              {infoSources.map(s => <li key={s} className="rounded-lg border border-white/15 px-3 py-1.5 text-sm text-white/80" data-id="element-166" data-mp="1tzrb8gwwt3fu">
                  {s}
                </li>)}
            </ul>
            <p className="mt-5 text-lg font-semibold text-ember" data-id="element-167" data-mp="23rx21nbfdetg">
              Il problema? Non sempre queste informazioni sono collegate tra loro.
            </p>
          </div>
          <div data-id="element-168" data-mp="1b3rgwzgglnt3">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-white/45" data-id="element-169" data-mp="1b414kge17ivm">E così continui a chiederti</p>
            <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-170" data-mp="1p3sdw3tlsb3a">
              {selfQuestions.map(q => <li key={q} className="flex gap-2.5 text-[15px] leading-snug text-white/80" data-id="element-171" data-mp="1k234esm145hb">
                  <span className="font-bold text-ember" aria-hidden="true" data-id="element-172" data-mp="30ft9o2ovwzsj">?</span>
                  {q}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-14 border-y border-white/10 py-10 text-center" data-id="element-173" data-mp="1t43nz6ygqmyx">
          <p className="text-lg text-white/60" data-id="element-174" data-mp="1y3qcicjqrpn1">Non è necessariamente un problema di motivazione.</p>
          <p className="mt-2 font-display text-5xl font-extrabold uppercase leading-none sm:text-7xl" data-id="element-175" data-mp="225bl3lp8thrf">
            È un problema di <span className="text-electric" data-id="element-176" data-mp="273v71m3u6tjs">organizzazione e metodo</span>.
          </p>
        </div>

        <ol className="divide-y divide-white/10" data-id="element-177" data-mp="1afow6hgbn4x2">
          {painPoints.map(({
          icon: Icon,
          title,
          body,
          list,
          resolve
        }) => <motion.li key={title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-4 py-9 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-12" data-id="element-178" data-mp="1edwbr8z1u06o">
              <div className="flex items-start gap-4" data-id="element-179" data-mp="voptto62xclx">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-ember/30 bg-ember/10 text-ember" data-id="element-180" data-mp="o68daxzscxjg">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-181" data-mp="j86tgaujcu6x" />
                </span>
                <h3 className="pt-1 font-display text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-182" data-mp="e7at279e7q69">
                  {title}
                </h3>
              </div>
              <div className="space-y-3 text-[15px] leading-relaxed text-white/70 lg:pt-1.5" data-id="element-183" data-mp="5749c3n3ptyn">
                {body.map(b => <p key={b} data-id="element-184" data-mp="g5ocqr647p2">{b}</p>)}
                {list && <ul className="space-y-1.5" data-id="element-185" data-mp="fcq6e69yqij">
                    {list.map(item => <li key={item} className="flex gap-2.5" data-id="element-186" data-mp="3rm71r5ylvddv">
                        <span className="text-ember" aria-hidden="true" data-id="element-187" data-mp="3mnvw77fcfp1g">—</span>
                        {item}
                      </li>)}
                  </ul>}
                {resolve && <p className="font-semibold text-white" data-id="element-188" data-mp="3ilhamfkaib6h">{resolve}</p>}
              </div>
            </motion.li>)}
        </ol>

        <div className="mt-8 rounded-2xl bg-electric px-6 py-9 text-center" data-id="element-189" data-mp="1hk1c2wy9ryhx">
          <p className="mx-auto max-w-2xl font-display text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-190" data-mp="1hm5pq6lz0bve">
            Se ti riconosci in queste situazioni, SIGMA SMART™ ha creato una soluzione per aiutarti.
          </p>
        </div>
      </div>
    </section>;
}